import { StatusFile } from '@/utils/enum';
import { BeraReportVersion } from '@/components/views/BeraJob/constants';

export type BeraReportStepKeyDTO = {
	id: string;
	step_id: string;
	step_key_id: string;
	stress_level_id: string;
	stress_level_score: number;
	frequency_id: string;
	frequency_score: number;
	total_task_duration_id: string;
	total_task_duration_score: number;
	job_element: string;
	task_rpn: number;
};

export const TASK_TIME_FORMAT = {
	MINUTES: 'minutes',
	SECONDS: 'seconds'
};

export type TaskTimeFormat = 'minutes' | 'seconds';

export type BeraReportDTO = {
	id: string;
	file_id: string;
	consolidated: boolean;
	task_id: string;
	task_time: number;
	task_time_format: TaskTimeFormat;
	has_known_injury: boolean;
	collection_date: string;
	step: number;
	step_key_results: BeraReportStepKeyDTO[];
};

export type BeraStepKeyResult = {
	id: string;
	task_rpn: number;
	job_element: string;
	stress_level_id: string;
	frequency_id: string;
	total_task_duration_id: string;
	step_key_id: string;
	step_key_name: string;
	step_id: string;
};

export type BeraReport = {
	id: string;
	rpn: number;
	task_time: number;
	task_time_format: TaskTimeFormat;
	collection_date: Date;
	has_known_injury: boolean;
	evaluator_id?: string | null;
	consolidated: boolean;
	bera_job_summary_id: string;
	operator_evaluated: string;
	bera_step_key_result: BeraStepKeyResult[];
	work_center: string;
	updated_at: Date;
	task_id: string;
	file_id: string;
	file_original_name: string | null;
};

export type BeraJobSummaryDTO = {
	id: string;
	company_id?: string;
	line_id: string;
	comment?: string;
	cycle_id: string;
	updated_at: Date;
	created_at?: Date;
	deleted_at?: Date;
	line_name: string;
	sector_id: string;
	cycle_name: string;
	report_name: string;
	sector_name: string;
	total_time?: number;
	overall_score: number;
	workstation_id: string;
	workstation_name: string;
	bera_report: BeraReport[];
	bera_job_summary_files: {
		id: string;
		bera_job_summary_id: string;
		file: {
			id: string;
			original_name: string;
		};
	}[];
	show_bera_result: boolean;
	show_bera_job_first_step: boolean;
	show_bera_report_first_tab: boolean;
	first_file_not_consolidated: string;
	version: BeraReportVersion;
	evaluator_id?: string | null;
	evaluator_name?: string | null;
	operator_evaluated?: string | null;
	work_center?: string | null;
	file_id?: string;
	file?: {
		id: string;
		original_name: string;
		duration: number | null;
		status?: StatusFile;
		processing_error?: string | null;
	} | null;
	is_revision?: boolean;
};

export type BeraJobSummaryFileResponse = {
	id: string;
	bera_job_id: string;
	file_id: string;
	created_at: Date;
	updated_at: Date;
	deleted_at: Date;
};

export type BindFilesToBeraJobSummaryResponse = BeraJobSummaryFileResponse[];

export type UpdateBeraJobSummaryFileDTO = {
	id: string;
	file_id: string;
	file_duration: number | null;
};

export type BeraReportStepKey = {
	id: string;
	step_id: string;
	step_key_id: string;
	stress_level_id: string;
	stress_level_score: number;
	frequency_id: string;
	frequency_score: number;
	total_task_duration_id: string;
	total_task_duration_score: number;
	job_element: string;
	task_rpn: number;
	action_plan_id: string;
};

export type BeraReportSegmentDTO = {
	id: string;
	segment_start: string;
	segment_end: string;
	sequence: number;
	duration: number;
	source_file_id?: string | null;
	source_file_name?: string | null;
};

export type BeraReportV2DTO = {
	id: string;
	task_id: string;
	file_id: string;
	bera_job_summary_id: string;
	task_name: string;
	segments: BeraReportSegmentDTO[];
	has_evaluation: number;
	is_evaluated: number;
	step: number;
	rpn?: number | null;
};

export type BeraReportsV2ListDTO = {
	total: number;
	limit: number;
	page: number;
	rows: BeraReportV2DTO[];
};
